<template>
    
    <ul style=" list-style-type: none;padding: 0;">
        <router-link to="/"> <li class="m-3 text-secondary">Accueil</li></router-link>
        <router-link to="/concept-sacs-publicitaires"><li class="m-3 text-secondary">Concept</li></router-link>

        <router-link to="/atouts-sacs-publicitaires"> <li class="m-3 text-secondary">Atouts</li></router-link>

    </ul>

</template>

<script>
export default ({
    name: "footer-Shop"
})
</script>


